import uiRouter, { StateService } from '@uirouter/angularjs';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { getFullName } from '@b2b/common/services/helpers';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import { TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { GridDefinitionFactory } from '@b2b/common/factories/gridDefinition/types';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';

MembershipListCardholdersController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$uibModal',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'PermissionsService',
  'ThemesHelperService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'ViewStateService',
  'CartService',
  'FeatureToggleService',
  'MembershipService',
  'UserPreferencesService',
];

function MembershipListCardholdersController(
  $scope: IScope & { membershipListCardholders: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $filter: IFilterService,
  $uibModal: UIBModalService,
  ApiService: ApiService,
  CalendarService: CalendarService,
  HelpersService: TODO,
  PermissionsService: PermissionsService,
  ThemesHelperService: ThemesHelperService,
  GridStateFactory: GridStateFactory,
  GridDefinitionFactory: GridDefinitionFactory,
  ViewStateService: TODO,
  CartService: CartService,
  FeatureToggleService: TODO,
  MembershipService: TODO,
  UserPreferencesService: UserPreferencesService
) {
  const ctrl = {
    model: [],
    filtered: [] as TODO,
    searchQuery: '',
    isLoaded: false,
    queryTimer: false as TODO | false,
    blockQuery: false,
    corporateSearch: false,
    searchCardType: '',
    viewId: '' as string | undefined,
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    membershipListCardholdersGridName: $state.current.name + '.cardholders.grid0',

    showMessageModal: {} as UIBModal<any>,

    memberActions: [
      {
        name: 'renew',
        action: 'renewMembership',
        label: 'Quick Renew',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'renewOptions',
        action: 'renewMembershipWithOptions',
        label: 'Renew Options',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'upgradeDowngrade',
        action: 'upgradeDowngradeMembership',
        label: 'Upgrade/Downgrade',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'cancel',
        action: 'cancelMembership',
        label: 'Cancel',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'renewUnavailable',
        action: 'noop',
        label: 'No more actions available',
        enabled: !PermissionsService.check('MEMBERSHIP_SALES'),
      },
    ],

    optionsOverride: {
      rowHeight: 40,
      data: 'membershipListCardholders.filtered',
      useAccessibleGrid: true,
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize) {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize);
        },
        onDataGridSortChange: function (grid, columns, page) {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          ctrl.onDblClick(item);
        },
        renewMembership: function (item) {
          ctrl.checkLifeCycle(item, null);
        },
        renewMembershipWithOptions: function (item) {
          ctrl.checkLifeCycle(item, 'renew');
        },
        upgradeDowngradeMembership: function (item) {
          ctrl.checkLifeCycle(item, 'upgradeDowngrade');
        },
        cancelMembership: function (item) {
          ctrl.cancelMembership(item);
        },
        transactAsMember: function (item) {
          ctrl.transactAsMember(item);
        },
        noop: function () {
          // do nothing
        },
        memberActions: function () {
          return ctrl.memberActions;
        },
      },
      columnDefs: [
        {
          field: 'view',
          displayName: 'View',
          width: 50,
          onCellNavClick: function (row, col) {
            ctrl.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'externalMembershipId',
          displayName: 'External Membership Id',
          headerTooltip: true,
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'membershipStanding',
          displayName: 'Membership Standing',
          headerTooltip: true,
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'name',
          displayName: 'Name on Card',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipCategory',
          displayName: 'ACME Level',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'firstName',
          displayName: 'First Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'email',
          displayName: 'Email',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'cardType',
          displayName: 'Card Type',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'streetAddress1',
          displayName: 'Address',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'city',
          displayName: 'City',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'state',
          displayName: 'State',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'zipCode',
          displayName: 'Zip',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipJoinedDateDisplay',
          displayName: 'Joined',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipExpirationDateDisplay',
          displayName: 'Expires',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'category',
          displayName: 'Category',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'subcategory',
          displayName: 'Subcategory',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'barcode',
          displayName: 'External Barcode',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeBarcode',
          displayName: 'ACME Barcode',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeCustomerNumber',
          displayName: 'ACME Customer Number',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeMembershipNumber',
          displayName: 'ACME Membership Number',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'constituentId',
          displayName: 'Constituent Id',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'externalConstituentId',
          displayName: 'External Constituent Id',
          headerTooltip: true,
          visible: false,
        },
      ] as TODO,
    },

    allowUpgradeExternalMemberships: false as string | boolean,

    init: function () {
      ctrl.viewId = $state.current.name;

      ctrl.gridDefinition.init(
        ctrl.membershipListCardholdersGridName,
        ctrl.optionsOverride,
        ctrl.viewId,
        $state.current.data.enablePreferences
      );

      ctrl.restoreViewState();

      ctrl.initGridColumns();

      ctrl.initConfigData();

      $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData);
      $scope.$on('MembershipListController::Search', ctrl.onMembershipListControllerSearch);
      $scope.$on('MembershipListController::AdvancedSearch', ctrl.onMembershipListControllerAdvancedSearch);

      $scope.$on('pageContent::startLoad', function (event, data) {
        if (data && data.from && data.from.name === 'application.membership.list') {
          switch (data.to.name) {
            case 'application.cart':
              ctrl.updateState();
              break;
          }
        }
      });
    },

    initConfigData: function () {
      ctrl.allowUpgradeExternalMemberships = ThemesHelperService.getCompany('allowUpgradeExternalMemberships');
    },

    initGridColumns: function () {
      if (ThemesHelperService.getCompany('auxiliaryMembership')) {
        ctrl.optionsOverride.columnDefs.splice(
          3,
          0,
          {
            field: 'auxiliary',
            displayName: 'Is Aux',
            cellTemplate:
              '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">{{ row.entity.auxiliary ? "Yes" : "No" }}</span></a></div>',
            headerTooltip: true,
            visible: true,
          },
          {
            field: 'membershipLevelCollectionName',
            displayName: 'Auxiliary Group',
            headerTooltip: true,
            visible: true,
          }
        );
      }
      if (
        FeatureToggleService.check('TENANT_CART') &&
        PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE'])
      ) {
        ctrl.optionsOverride.columnDefs.push({
          field: 'transact',
          displayName: 'Transact',
          width: 110,
          minWidth: 110,
          onCellNavClick: function (row, col) {
            ctrl.optionsOverride.appScopeProvider.transactAsMember(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">' +
            '<div class="btn-group dropdown" uib-dropdown dropdown-append-to-body="true" data-ng-if="(row.entity.membershipStanding !==  \'new\')">' +
            '<button id="membership-list-dropdown-action" data-ng-click="grid.appScope.transactAsMember(row)" ' +
            'class="membership-list-dropdown-action btn btn-primary btn-xs">Transact<span class="sr-only"> as {{ row.entity.name }}</span> </button>' +
            '<button class="btn btn-primary btn-xs dropdown-toggle" uib-dropdown-toggle>' +
            '<span class="caret"></span>' +
            '<span class="sr-only"> Renew actions for {{ row.entity.name }}</span>' +
            '</button>' +
            '<ul class="dropdown-menu dropdown-menu-right membership-list-dropdown-action" uib-dropdown-menu role="menu" aria-labelledby="membership-list-dropdown-action">' +
            '<li role="menuitem" data-ng-if="memberAction.enabled" data-ng-repeat="memberAction in grid.appScope.memberActions()">' +
            '<a href class="font-small" data-ng-click="grid.appScope[memberAction.action](row)">' +
            '<span>{{ memberAction.label }}</span>' +
            '</a>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '</div>',
          visible: true,
          enableSorting: false,
        });
      }
    },

    updateState: function () {
      const state = {
        page: ctrl.gridState.getPropertyValue('page'),
        pageSize: ctrl.gridState.getPropertyValue('pageSize'),
        search: ctrl.searchQuery,
      };

      ViewStateService.setState('membership.list', state);
    },

    restoreViewState: function () {
      const viewState = ViewStateService.getState('membership.list');

      if (viewState.page) {
        ctrl.gridState.setPropertyValue('page', viewState.page);
        ctrl.gridDefinition.setPageNumber(viewState.page);
        ctrl.gridState.setPropertyValue('pageSize', viewState.pageSize);
      }

      if (viewState.search) {
        ctrl.gridState.setPropertyValue('search', viewState.search);
      }
    },

    initData: function () {
      const props: TODO = ctrl.gridState.getGridState();

      if (props.searchMode && props.searchMode === 'advancedSearch') {
        // noop
      } else {
        ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        ctrl.setSearchMode('search');

        ctrl.getMembers();
      }
    },

    /**
     * @param {'search' | 'advancedSearch'} searchMode Determines which API is going to be used to get the memberships list
     */
    setSearchMode: function (searchMode) {
      ctrl.gridState.setPropertyValue('searchMode', searchMode);
    },

    getMembers: function () {
      const props: TODO = Object.assign({}, ctrl.gridState.getGridState());

      ctrl.blockQuery = true;
      ctrl.isLoaded = false;
      ctrl.gridDefinition.isLoaded = false;

      $scope.$emit('MembershipList::Loaded', { isLoaded: ctrl.gridDefinition.isLoaded });

      if (props.searchMode === 'advancedSearch') {
        if (props.exactMatch === 'true') {
          ApiService.membership.summaries.exactSearch(props).then(ctrl.success.getMembers, ctrl.error.getMembers);
        } else {
          ApiService.membership.summaries.advancedSearch(props).then(ctrl.success.getMembers, ctrl.error.getMembers);
        }
      } else {
        props.corporate = ctrl.corporateSearch;

        if (ctrl.searchQuery && ctrl.searchQuery.length) {
          props.cardType = ctrl.searchCardType;
        }

        ApiService.membership.summaries.search(props).then(ctrl.success.getMembers, ctrl.error.getMembers);
      }
    },

    query: function () {
      ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);

      if (ctrl.queryTimer) {
        $timeout.cancel(ctrl.queryTimer);
      }

      ctrl.queryTimer = $timeout(function () {
        $scope.$broadcast('DataGrid::Search', { name: ctrl.membershipListCardholdersGridName });
      }, 300);
    },

    search: function () {
      ctrl.filtered = $filter('filter')(ctrl.filtered, function (member: TODO) {
        const number = member.externalMembershipId || '';
        const name = member.name || '';
        const email = member.email || '';
        const value = (number + name + email).toLowerCase();
        console.log(
          'ProgramsController::search',
          member.name,
          ctrl.searchQuery,
          value.indexOf(ctrl.searchQuery.toLowerCase()) !== -1
        );
        return value.indexOf(ctrl.searchQuery.toLowerCase()) !== -1 ? member : null;
      });
    },

    process: function (members) {
      if (members instanceof Array) {
        for (let i = 0, ii = members.length; i < ii; i++) {
          members[i].membershipJoinedDateDisplay = $filter('date')(
            CalendarService.parseDate(members[i].membershipJoinedDate),
            ctrl.dateFormat
          );
          members[i].membershipExpirationDateDisplay = $filter('date')(
            CalendarService.parseDate(members[i].membershipExpirationDate),
            ctrl.dateFormat
          );
        }
      } else {
        members = [];
      }

      return members;
    },

    cancelMembership: function (item) {
      const membership = item.entity;

      ApiService.membership.eligibility
        .listByMembershipCategory({
          membershipId: item.entity.membershipId,
          saleChannels: 'insideSalesIndividual',
          actions: CartService.memberships.ENUMS['cancel'].join(),
          summarize: 0,
        })
        .then(function (response) {
          const canCancel = response.data.payload.canCancel;

          if (!canCancel) {
            return Promise.reject();
          }

          const organizationOrderInput = {
            memberships: [
              {
                itemType: 'MembershipCancel',
                membershipInfo: {
                  membershipId: membership.membershipId,
                  membershipOfferingId: membership.offeringId,
                  waiveBenefits: false,
                  pricePointId: membership.pricePointId,
                  notifyGiftRecipient: false,
                  isGift: membership.isGift,
                  membershipCategoryId: membership.categoryId,
                  membershipCards: [membership],
                },
              },
            ],
          };

          return ApiService.orders.checkout.charges(organizationOrderInput).then(function (response) {
            ctrl.goToState({ membership: membership, state: 'application.membership.cancel', lifecycleType: null });
          });
        })
        .catch(function () {
          ctrl.showMessage({
            title: 'Membership is not eligible',
            message: ['The membership for', membership.name, 'is not eligible to cancel'].join(' '),
          });
        });
    },

    checkLifeCycle: function (item, type) {
      const isQuickRenew = !type;
      const lifecycleType = type || 'renew';

      CartService.memberships
        .lifecycle(CartService.memberships.ENUMS[lifecycleType], {
          membershipId: item.entity.membershipId,
          membershipCategory: item.entity.membershipCategory,
          membershipName: item.entity.name,
        })
        .then(function (response) {
          const allowUpgrade =
            !response.data.payload.hasOwnProperty('externalMembership') ||
            !response.data.payload.externalMembership ||
            (ctrl.allowUpgradeExternalMemberships && response.data.payload.externalMembership);
          const found = CartService.memberships.hasPricepointMatch(item.entity, response.data.payload);

          if (isQuickRenew && found) {
            ctrl.updateOrderContact({
              membership: item.entity,
              callBack: function () {
                CartService.memberships
                  .addToCart(
                    angular.extend(item.entity, {
                      itemType: MembershipService.getPurchaseType(found.type || 'renew'),
                      amount: found.pricepoint.price,
                      orderContactId: item.entity.customerId,
                    })
                  )
                  .then(ctrl.success.renewMembership)
                  .catch(ctrl.error.checkLifeCycle);
              },
              lifecycleType: null,
              allowUpgrade: null,
            });
          } else {
            ctrl.updateOrderContact({
              membership: item.entity,
              callBack: function () {
                ctrl.goToState({
                  membership: item.entity,
                  state: 'application.membership.retail',
                  lifecycleType,
                });
              },
              lifecycleType,
              allowUpgrade,
            });
          }
        })
        .catch(ctrl.error.checkLifeCycle);
    },

    transactAsMember: function (item) {
      ctrl.updateOrderContact({
        membership: item.entity,
        callBack: function () {
          ctrl.goToState({ membership: item.entity, state: 'application.programs.list', lifecycleType: null });
        },
        lifecycleType: null,
        allowUpgrade: null,
      });
    },

    updateOrderContact: function (params: { membership: any; callBack: any; lifecycleType: any; allowUpgrade: any }) {
      const hasNewMembershipPurchase = !!CartService.memberships.hasNewMembership();
      const isUpgradeDowngrade = params.lifecycleType && params.lifecycleType === 'upgradeDowngrade';
      const hasMembershipsInCart = CartService.memberships.hasMemberships();
      const hasItemsInCart = !!CartService.getItems().length;
      const isOrderContact = CartService.isOrderContact(params.membership.customerId);

      const showPrompt =
        (CartService.hasOrderContact() && !isOrderContact) ||
        hasNewMembershipPurchase ||
        (isOrderContact && isUpgradeDowngrade && (hasMembershipsInCart || hasItemsInCart)) ||
        (isUpgradeDowngrade && !params.allowUpgrade);

      let title = 'Are you sure?';
      let message: string | null = null;
      let cancel = 'Cancel';
      let button = 'Continue';
      let hideButton = false;

      if (showPrompt) {
        if (hasNewMembershipPurchase) {
          message = 'Continuing will remove any memberships in the cart.';
        } else if (!params.membership.customerId) {
          message =
            'Do you want to change the transacting member from ' +
            getFullName(CartService.getOrderContact()) +
            '?' +
            '<br><br>Doing so will remove any memberships in the cart.';
        } else if (isUpgradeDowngrade && !params.allowUpgrade) {
          title = 'Membership not eligible';
          message =
            'This membership was created outside of ACME. You cannot Upgrade / Downgrade within ACME, due to your current configuration.';
          cancel = 'Close';
          hideButton = true;
        } else if (isOrderContact && isUpgradeDowngrade && hasMembershipsInCart) {
          message =
            'The cart already contains a membership for ' +
            getFullName(CartService.getOrderContact()) +
            '.' +
            ' <br><br>Adding this new membership will clear the current membership from the cart.';
          button = 'Update Cart';
        } else if (isOrderContact && isUpgradeDowngrade && hasItemsInCart) {
          message =
            'Please add membership and tickets separately. Once you Upgrade / Downgrade, tickets will reflect applicable benefits.';
          cancel = 'Buy Tickets First';
          button = 'Upgrade / Downgrade Membership First';
        } else {
          message =
            'Do you want to transact as ' +
            getFullName(params.membership) +
            ' instead of ' +
            getFullName(CartService.getOrderContact()) +
            '? ' +
            '<br><br>Doing so will remove any memberships in the cart.';
        }

        ctrl
          .showMessage({
            title: 'Are you sure?',
            message: message,
            okText: button,
            cancelText: cancel,
            hideOkText: hideButton,
          })
          .then(function () {
            CartService.cancelCart().then(function () {
              ctrl.updateContactAndProceed(params.membership, params.callBack);
            });
          })
          .catch(function () {
            // do nothing
          });
      } else {
        ctrl.updateContactAndProceed(params.membership, params.callBack);
      }
    },

    updateContactAndProceed: function (membership, callBack) {
      CartService.memberships
        .updateOrderContact({
          membershipId: membership.membershipId,
          orderContactId: membership.customerId,
        })
        .then(callBack, ctrl.error.updateContact);
    },

    goToState: function (params: { membership: any; state: any; lifecycleType: any }) {
      const props: {
        membershipId: any;
        orderContactId?: any;
        lifecycleType?: any;
      } = {
        membershipId: params.membership.membershipId,
      };

      ctrl.updateState();

      if (params.membership.customerId) {
        props.orderContactId = params.membership.customerId;
      }

      if (params.lifecycleType) {
        props.lifecycleType = params.lifecycleType;
      }

      $state.go(params.state, props);
    },

    /**
     * @param {object} props
     * @param {string} props.title
     * @param {string} props.message
     * @param {string?} props.okText
     * @param {string?} props.cancelText
     * @returns {Promise<any>}
     */
    showMessage: function (props) {
      if (!props.message) {
        return Promise.resolve(undefined);
      }

      ctrl.showMessageModal = $uibModal.open({
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        size: 'md',
        controller: 'ConfirmCustomModalController',
        resolve: {
          modalTitle: function () {
            return props.title;
          },
          modalMessage: function () {
            return props.message;
          },
          okText: function () {
            return props.okText || 'Done';
          },
          cancelText: function () {
            return props.cancelText || 'Cancel';
          },
          hideOkText: function () {
            return !!props.hideOkText;
          },
        },
      });

      // Invoked when modal completes with close(params)
      return ctrl.showMessageModal.result;
    },

    navigateToNewMembership: function () {
      const membership = CartService.getTransactingMembership();
      const orderContact = CartService.getOrderContact();

      const props = {
        membershipId: membership.id,
        customerId: orderContact?.customerId,
      };

      ctrl.goToState({ membership: props, state: 'application.membership.retail', lifecycleType: null });
    },

    showMembershipMessage: function () {
      const membership = CartService.getTransactingMembership();
      const orderContact = CartService.getOrderContact();
      const title = 'Proceeding will clear the cart';
      const message =
        getFullName(orderContact) +
        ' already has a membership: ' +
        membership.membershipCategory +
        ' (expiring ' +
        membership.membershipExpirationDateDisplay +
        '). Adding a new membership will remove the currently transacting member and clear contents of the cart.';

      ctrl.showMessageModal = $uibModal.open({
        templateUrl: 'views/application/views/membership/list/modals/member/member.tpl.html',
        size: 'md',
        controller: 'MembershipListModalsMemberController',
        resolve: {
          modalTitle: function () {
            return title;
          },
          modalMessage: function () {
            return message;
          },
          showRenew: function () {
            return false;
          },
        },
      });

      ctrl.showMessageModal.result.then(
        function (response) {
          const props = {
            membershipId: membership.id,
            customerId: orderContact?.customerId,
          };

          if (response === 'renew') {
            ctrl.goToState({ membership: props, state: 'application.membership.retail', lifecycleType: null });
          } else if (response === 'clear') {
            CartService.cancelCart().then(ctrl.success.clearMember, ctrl.success.clearMember);
          }
        },
        function (response) {
          // Close modal, do nothing
        }
      );
    },

    success: {
      init: function (response) {
        // noop
      },
      getMembers: function (response) {
        ctrl.filtered = ctrl.process(response.data.payload.list);
        ctrl.isLoaded = true;
        ctrl.gridDefinition.isLoaded = true;
        ctrl.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);

        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.filtered.length,
            totalItems: ctrl.gridState.getPropertyValue('totalItems'),
          });

          $scope.$emit('MembershipList::Loaded', { isLoaded: ctrl.gridDefinition.isLoaded });

          $timeout(function () {
            ctrl.blockQuery = false;
          }, 100);
        }, 10);
      },

      renewMembership: function (response) {
        $scope.$emit('Cart::Open', {
          itemName: MembershipService.getLifeCycleLabel(MembershipService.getPurchaseType('renew')),
        });
      },
      clearMember: function (response) {
        $scope.$emit('Cart::Close');
        $state.go('application.membership.retail');
      },
    },

    error: {
      init: function (response) {
        // noop
      },
      getMembers: function (response) {
        $scope.$emit('MembershipList::Error', { response: response });
      },
      getMembershipEligibility: function () {
        ctrl.showMessage({
          title: 'An error occurred',
          message: 'Unable to retrieve eligible sales actions for this membership.',
        });
      },
      checkLifeCycle: function (response) {
        ctrl.showMessage({ title: response.data.title, message: response.data.error });
      },
      updateContact: function (response) {
        ctrl.showMessage({ title: 'An error occurred', message: response.data.error });
      },
      clearMember: function (response) {
        ctrl.showMessage({ title: 'An error occurred', message: response.data.error });
      },
    },

    onDataGridSortChange: function (grid, columns, page) {
      const data = columns[0];

      if (data) {
        if (!ctrl.blockQuery) {
          ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          ctrl.getMembers();
        } else {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.filtered.length,
            totalItems: ctrl.gridState.getPropertyValue('totalItems'),
          });
        }
      }
    },

    onDblClick: function (item) {
      // Create and edit are handled by the same controller
      ctrl.updateState();
      console.log('MembershipListController::onGridDblClick', item.entity.membershipId);
      $state.go('application.membership.detail', { id: item.entity.membershipId, searchName: item.entity.name });
    },

    onDataGridPaginate: function (newPage, pageSize) {
      if (!ctrl.blockQuery) {
        ctrl.gridState.updateGridState(newPage, pageSize);
        ctrl.getMembers();
      } else {
        $scope.$broadcast('DataGrid::ResizeGrid', {
          name: ctrl.gridDefinition.options.gridName,
          datasetLength: ctrl.filtered.length,
          totalItems: ctrl.gridState.getPropertyValue('totalItems'),
        });
      }
    },

    onDestroy: function () {
      if (ctrl.queryTimer) {
        $timeout.cancel(ctrl.queryTimer);
      }
    },

    onMembershipListControllerSearch: function (e, data) {
      ctrl.searchQuery = data.searchQuery;
      ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
      ctrl.setSearchMode('search');

      if (data.searchType === 'organizations' && data.searchCardholders) {
        ctrl.corporateSearch = true;
        ctrl.searchCardType = 'primary';
        ctrl.getMembers();
      } else if (data.searchType === 'individual') {
        ctrl.corporateSearch = false;
        ctrl.getMembers();
      }
    },

    /**
     *
     * @param {*} e
     * @param {{ filters: Record<string, string>}} data
     */
    onMembershipListControllerAdvancedSearch: function (e, data) {
      // Reset basic search properties
      ctrl.searchQuery = '';
      ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
      ctrl.corporateSearch = false;

      /** 
       * APP-3159 AC3: Update UI to better clarify what we are searching on for IDs/Barcodes - split into 2 values with the following labels:
       * - ACME Membership Number or External Membership ID
       * - ACME Barcode or External Barcode
       * 
       * visually looks like 2 fields ['memberId', 'barcodeId'], but should be only 1 ['memberId']
       * */ 
      if (!data.filters['exactMatch']) {
        data.filters['memberId'] = ['memberId', 'barcode']
          .filter((current) => data.filters[current])
          .map((current) => data.filters[current])
          .join(' ');
      }

      const validAdvancedFilters = [
        'exactMatch',
        'firstName',
        'lastName',
        'address',
        'zip',
        'email',
        'memberId',
        'barcode',
        'cardName',
      ];

      validAdvancedFilters.forEach(function (key) {
        const value = data.filters[key] || '';
        ctrl.gridState.setPropertyValue(key, value);
      });

      ctrl.setSearchMode('advancedSearch');

      ctrl.getMembers();
    },
  };

  $scope.membershipListCardholders = ctrl;

  ctrl.init();
}

export const MembershipListCardholdersControllerModule = angular
  .module('acme.view.application.membership.list.cardholders.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.membership',
    'acme.common.service.featureToggle',
    'acme.common.service.themesHelper',
    'acme.common.service.viewState',
    CartServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.view.application.modals.confirm.controllers',
    'acme.view.application.modals.confirmCustom.controllers',
    'acme.view.application.membership.list.modals.member.controllers',
  ])
  .controller('MembershipListCardholdersController', MembershipListCardholdersController).name;
